<template>
  <div ref="wrapper">
    <div class="banner">
      <img src="../../../assets/img/banner.png" class="img" alt="">
    </div>
    <!-- 初始化加载动画 -->
    <div class="flex-aj-c" v-if="loading && searchForm.page == 1">
      <Lottie styleObj="width:200px" path="./loading.json"></Lottie>
    </div>
    <div class="wrapper" v-else>
      <div class="t-header">
        <div class="name">
          {{ courseName }}
        </div>
        <div class="hot-new-box">
          <div class="item" v-for="(item, index) in hotNew" :key="item.id">
            <span :class="hotNewIndex == index ? 'color2' : ''" @click="statusClick(item, index)">{{ item.text }}</span>
            <div class="icon-box">
              <div class="iconfont icon-xiangshang1" :class="item.order == 'asc' ? 'green' : ''"
                @click="statusClick(item, index, 'asc')"></div>
              <div class="iconfont icon-xiangxia1" :class="item.order == 'desc' ? 'green' : ''"
                @click="statusClick(item, index, 'desc')"></div>
            </div>
          </div>


          <el-dropdown style="display:flex" class="item">
            <span class="color4 fs14" :class="hotNewIndex == 2 ? 'green' : ''">{{ courseType[courseTypeindex].text
            }}</span>
            <div class="icon-box">
              <div class="iconfont icon-xiangxia1" :class="hotNewIndex == 2 ? 'green' : ''"></div>
            </div>
            <el-dropdown-menu slot="dropdown" style="text-align:center">
              <el-dropdown-item @click.native="courseTypeClcik(index)" v-for="(item, index) in courseType"
                :key="item.id">{{ item.text }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 列表 -->
      <template v-if="list && list.length > 0">
        <div class="list-wrapper">
          <div class="item" v-for="(item) in list" :key="item.id" @click="goplay(item)">
            <div class="item-top-box">
              <img :src="item.course_cover_url" class="topimg" alt="">
              <div class="tag flex-aj-c color3 fs13">
                {{ item.attribute == '2' ? '系列课' : '单节课' }}
              </div>
            </div>

            <div class="item-content">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="flex-a-c study_status">
                <span class="color1 fs13 mr37">{{ item.course_pv }}次学习热度</span>
                <span class="color2 fs13 mr37">{{ item.course_uv }}人学习过</span>
              </div>
            </div>
          </div>
        </div>

        <div class="load-compelete" v-show="list.length == total">
          已经到底啦
        </div>
      </template>
      <template v-else>
        <div class="flex-aj-c">
          <div class="nothing-box">
            <i class="iconfont icon-queshengye_zanwushuju"></i>
            <div class="nothing">
              暂无课程
            </div>
          </div>
        </div>
      </template>
      <!-- 上拉加载动画 -->
      <div class="flex-aj-c loadmore-lottie" v-show="loading && searchForm.page > 1">
        <Lottie styleObj="width:100px" idattr="loading2" path="./loading.json"></Lottie>
      </div>
      <!-- 回到顶部 -->
      <img src="./img/up.png" v-show="backtopShow" class="up-icon" alt="" @click="backtop">

    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Lottie from "@/components/Lottie";
export default {
  name: 'homelist',
  components: {
    Lottie
  },
  data() {
    return {
      backtopShow:false,
      courseName: '精品课堂',
      courseId: "", //课程id
      hotNewIndex: 2,
      loading: false,
      searchForm: {
        page: 1,
        page_size: 16,
        posid: 1,
        prop: "",
        order: "",
        Attr: ''
      },
      courseTypeindex: 0,
      courseType: [
        {
          text: '全部',
          id: ''
        },
        {
          text: '单节课',
          id: 1
        },
        {
          text: '系列课',
          id: 2
        },
      ],
      list: [],
      total: 0,
      hotNew: [
        {
          text: '最新',
          id: 1,
          prop: 'time_add',
          order: '', // asc 正序 desc 倒叙
        },
        {
          text: '最热',
          id: 2,
          prop: 'course_pv',
          order: '', // asc 正序 desc 倒叙
        }
      ]
    }
  },

  watch: {
    '$store.state.screenTop': {
      deep: true,
      handler: function (newv, oldv) {
        if(newv<100){
          this.backtopShow = false
        }else{
          this.backtopShow = true
        }
        this.handleScroll(newv, oldv)
      }
    }
  },

  mounted() {
    const query = this.$route.query
    this.courseName = query.course ? query.course : '精品课堂'
    this.searchForm.cate = query.courseid
    this.searchForm.page = 1
    this.getList()
  },

  methods: {
      ...mapMutations(['set_state']),
    handleScroll(newv, oldv) {
      const boxHeight = this.$refs.wrapper.scrollHeight
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (boxHeight - newv <= windowHeight) {
        this.loadMore()
      }
    },
    // 加載更多
    loadMore() {
      if (this.total > this.list.length) {
        this.searchForm.page++
        this.getList()
      }
    },
    goplay(item) {
      // 新开页面
      let routeData = this.$router.resolve({
        path: `/count_center/player/${item.id}`
      });
      window.open(routeData.href, "_blank");

    },
    courseTypeClcik(index) {
      if (this.courseTypeindex == index) return
      this.hotNewIndex = 2
      this.searchForm.Attr = this.courseType[index].id
      this.searchForm.page = 1
      this.courseTypeindex = index
      this.getList()
    },
    // 导航栏操作
    navClick(data) {
      const query = this.$route.query
      this.searchForm = Object.assign({}, this.searchForm, data)
      this.courseName = data.search ? '搜索结果' : query.course ? query.course : '精品课堂'
      this.searchForm.course = undefined
      this.searchForm.page = 1
      this.searchForm.posid = (data.cate == 0 && data.search == '') ? 1 : '',
        this.searchForm.prop = ''
      this.searchForm.order = ''
      this.searchForm.Attr = ''
      this.courseTypeindex = 0
      this.hotNewIndex = 2
      this.getList()
    },
    async getList() {
      this.loading = true
      if (this.searchForm.page == 1) {
        this.list = []
      }
      const [err, res] = await this.$http.post("home/index", this.searchForm);
      this.loading = false
      if (err) {
        return
      }
      this.total = res.total
      if (res.list && res.list.length > 0) {
        if (this.searchForm.page == 1) {
          this.list = res.list
        } else if (this.searchForm.page > 1) {
          this.list = this.list.concat(res.list)
        }
      }
    },
    backtop() {
      this.set_state({name:'screenTop',value:0})
      this.set_state({name:'is_click_back_top',value:true})
      this.$emit('backtop')
    },
    // 排序点击
    statusClick(item, index, order) {
      if (this.hotNewIndex == index && this.searchForm.order == order) return
      this.hotNewIndex = index
      this.searchForm.page = 1
      this.searchForm.prop = this.hotNew[index].prop
      if (order) {
        this.hotNew[index].order = order
        this.searchForm.order = order
      } else {
        let order_temp = ''
        switch (this.hotNew[index].order) {
          case '':
            order_temp = 'asc'
            break;
          case 'asc':
            order_temp = 'desc'
            break;
          case 'desc':
            order_temp = ''
            break;
        }
        this.hotNew[index].order = order_temp
        this.searchForm.order = order_temp
      }

      this.getList()
    }
  }

}
</script>

<style lang="less" scoped>
.banner {
  margin-bottom: 40px;

  .img {
    height: 300px;
    width: 100%;
    object-fit: cover;
  }
}

.wrapper {
  width: 1200px;
  position: relative;
  margin: 0 auto;

  .t-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .name {
      color: #23262F;
      font-size: 24px;
      font-weight: 600;
    }

    .hot-new-box {
      width: 240px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #23262F;
      font-size: 14px;

      .item {
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;

        &::after {
          content: '';
          width: 1px;
          height: 18px;
          background: #D8D8D8;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -50%;
        }

        &:nth-last-child(1)::after {
          width: 0;
        }

        .icon-box {
          line-height: 8px;
          margin-left: 6px;
        }

        .icon-xiangshang1,
        .icon-xiangxia1 {
          font-size: 12px;
        }
      }
    }
  }

  .list-wrapper {
    display: flex;
    flex-wrap: wrap;


    .item {
      width: 280px;
      height: 239px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-right: 26px;
      margin-bottom: 26px;
      box-sizing: border-box;
      transition: all 0.3s;
      /* 上浮这个过程需要的时间 */
      cursor: pointer;

      &:hover {
        box-shadow: 0px 4px 12px #D5D5D5;
        transform: translate(0, -10px);
        /* 鼠标悬浮时盒子上移10px */
      }

      &:nth-child(4n) {
        margin-right: 0;
      }

      .item-top-box {
        position: relative;

        .topimg {
          width: 280px;
          height: 140px;
          object-fit: cover;
          display: block;
          border-radius: 8px 8px 0 0;
        }

        .tag {
          width: 49px;
          height: 21px;
          background: rgba(0, 0, 0, 0.7000);
          border-radius: 4px 0px 0px 0px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }


      .item-content {
        padding: 14px 14px 0 14px;
        box-sizing: border-box;
        height: 99px;
        position: relative;

        .title {
          font-size: 15px;
          font-weight: bold;
          color: #23262F;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 14px;
        }
        .study_status{
          position: absolute;
          bottom: 14px;
        }
      }
    }
  }
}

.loadmore-lottie {
  bottom: 0;
  width: 1200px;
}

.icon-queshengye_zanwushuju {
  font-size: 200px;
  color: #ddd;
}

.nothing-box {
  text-align: center;

  .nothing {
    color: #999;
    font-size: 16px;
  }
}

.load-compelete {
  color: #777E90;
  font-size: 12px;
  text-align: center;
  padding: 94px 0;
}

.green {
  color: #2AB18B
}

:deep(.el-dropdown-menu__item:hover) {
  color: #2AB18B
}

.up-icon {
  cursor: pointer;
  width: 76px;
  height: 76px;
  position: fixed;
  z-index: 99;
  right: 260px;
  bottom: 94px;
}

@media screen and (max-width: 1500px) {
  .up-icon {
    right: 0;
  }
}

@media (min-width: 1501px) and (max-width: 1800px) {
  .up-icon {
    right: 5%;
  }
}
</style>

